module.exports = __webpack_public_path__ + "static/img/ic_empty_state_one@3x.ce753804.png";